import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Header from "./Header";

const Page = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Body = styled.main`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  min-height: 0;
`;

export default function AppLayout() {
  return (
    <Page>
      <Header />
      <Body>
        <Outlet />
      </Body>
    </Page>
  );
}
